import type { Icon } from '@phosphor-icons/react';

interface StorageStatCardProps {
    icon: Icon;
    label: string;
    value: string;
    description: string;
}

export function StorageStatCard({
    icon: IconComponent,
    label,
    value,
    description,
}: StorageStatCardProps) {
    return (
        <div className="border border-grey-600 rounded-[10px] p-4 flex flex-col gap-3">
            <div className="flex items-center gap-2">
                <IconComponent className="size-4 text-grey-200" />
                <span className="text-sm text-grey-200">{label}</span>
            </div>
            <span className="text-lg text-white-100 leading-7">{value}</span>
            <span className="text-xs text-grey-400 leading-5">
                {description}
            </span>
        </div>
    );
}
